import { ChannelProvider } from "@sendbird/uikit-react/Channel/context";
import { ChannelHeader } from "../conversations/channel-header";
import { MessageInput } from "../conversations/message-input";
import { ChannelDetails } from "../sendbird-chat/channel-details";
import { ArrowLeft, X } from "lucide-react";
import { useAuth } from "../auth/auth-context";

interface ChatDetailProps {
  currentChannelUrl: string | null;
  onBack: () => void;
  onClose: () => void;
}

export const ChatDetail = ({
  currentChannelUrl,
  onBack,
  onClose,
}: ChatDetailProps) => {
  const { user } = useAuth();

  if (!currentChannelUrl) {
    return null;
  }

  return (
    <ChannelProvider channelUrl={currentChannelUrl} replyType="QUOTE_REPLY">
      <ChannelDetails
        currentChannelUrl={currentChannelUrl}
        channelHeader={
          <ChannelHeader
            isSupervisorChannel
            leftElement={
              user?.role !== "MENTOR" && (
                <button
                  className="rounded-full p-1 hover:bg-gray-100"
                  onClick={onBack}
                >
                  <ArrowLeft className="h-5 w-5" />
                </button>
              )
            }
            rightElement={
              <button
                className="rounded-full p-1 hover:bg-gray-100"
                onClick={onClose}
              >
                <X className="h-5 w-5" />
              </button>
            }
          />
        }
        messageInput={
          <MessageInput
            shouldShowAiConversation={false}
            shouldShowVideoCallButton
            isSupervisorView={true}
          />
        }
      />
    </ChannelProvider>
  );
};
